import { drawImage, getContext } from './images.js'
import { ResetMain, PrepareLevel, LevelNumber, levelNumber } from './main.js'
import { PlayTrack, StopTrack } from './music.js'
import { ActivateScene, DeactivateScene } from './sceneController.js'
import { Reset as DialogReset } from './scene-dialog.js'
import { Reset as CreditsReset } from './scene-credits.js'
import * as SFX from './sfx.js'
import { GetHint } from './levels.js'

let ctx = null
let titleX = 0

let menuSelect = 0
let currentMenu = 'initial'
let menu = []
let menuOptions = {
    initial: { options: ['START', 'CREDITS'], backTo: ''},
    start: { options: ['KEYBOARD', 'GAMEPAD', '< BACK'], backTo: 'initial' },
    keyboard: { options: ['Move: Arrows', 'Spray: Space', 'Suction: L.Shift', 'BEGIN', '< BACK'], backTo: 'start'},
    gamepad: { options: ['Move: D.Pad', 'Spray: A', 'Suction: R.Trig', 'BEGIN', '< BACK'], backTo: 'start'}
}
SetMenuOptions(currentMenu)

function MenuChange(row, col) {
    menuSelect += row
    menuSelect = menuSelect >= menu.length - 1 ? menu.length - 1 : menuSelect
    menuSelect = menuSelect < 0 ? 0 : menuSelect
}


function ShadowText(x, y, text, fgcolor, shadowColor, bgColr, fontobj) {
    if (!ctx) {
        ctx = getContext()
    }
    fontobj = fontobj !== undefined ? fontobj : font
    fgcolor = fgcolor !== undefined ? fgcolor : '#f1f1f1ff'
    shadowColor = shadowColor !== undefined ? shadowColor : '#000000ff'
    let effects = bgColr !== undefined ? { background: { colour: bgColr } } : {}
    bfontjs.DrawText(ctx, x + 1, y, text, shadowColor, fontobj, effects)
    bfontjs.DrawText(ctx, x, y + 1, text, shadowColor, fontobj, effects)
    bfontjs.DrawText(ctx, x, y, text, fgcolor, fontobj, effects)
}

function SetMenuOptions(menuId) {
    menuId = menuId.toLowerCase()
    if (menuId === '< back') {
        menuId = menuOptions[currentMenu].backTo
    }
    currentMenu = menuId
    try {
        menu = menuOptions[currentMenu].options
        menuSelect = 0
    } catch {}
}

function MenuSelect() {
    if (menu[menuSelect] === 'BEGIN') {
        SFX.PlayTrack('clouds')
        ActivateScene('transition-clouds-in', (params) => {
            if (params.frame === params.maxFrame) {
                DeactivateScene('transition-clouds-in')
                DeactivateScene('menu')
                StopTrack('Menu')
                levelNumber = 1
                let levelid = 'level' + levelNumber
                PrepareLevel(levelid)
                ResetMain()
                DialogReset([levelid, GetHint(levelid)])
                ActivateScene('dialog')

                ActivateScene('main')
                ActivateScene('transition-clouds-out', (params) => {
                    if (params.frame === 0) {
                        DeactivateScene('transition-clouds-out')
                    }
                })
            }
        })
    } else if (menu[menuSelect] === 'CREDITS') {
        CreditsReset()
        ActivateScene('credits')
    } else {
        SetMenuOptions(menu[menuSelect])
    }
}

function Reset() {
    menuSelect = 0
    PlayTrack('Menu')
}

function AnimationFrame(delta) {
    if (!ctx) {
        ctx = getContext()
    }
    //ctx.clearRect(0, 0, 64, 64)
    drawImage('title-bg', 0, 0, { x: parseInt(titleX), y: 0, w: 64, h: 64 })
    drawImage('title-bg', parseInt(128 - titleX), 0, { x: 0, y: 0, w: 64, h: 64 })
    
    drawImage('title-text', 1, 5)

    menu.forEach((text, index) => {
        bfontjs.DrawText(ctx, 32 - parseInt(bfontjs.CalculateTextWidth(text, eighties) / 2), 24 + index * 8, text, menuSelect === index ? '#fffc40ff' : '#f1f1f1ff', eighties, { background: { colour: '#000000d9'} })
    })

    titleX += delta * 0.1
    titleX = titleX > 128 ? 0 : titleX
}

export { AnimationFrame, Reset, MenuChange, MenuSelect, ShadowText }